import React, { ComponentProps } from 'react';

import HostedField from '../HostedField';
import InputSocket from '../InputSocket';

import { CreditCardPCIFields } from '../../types';

type SecurityCodeProps = {
  /**
   * HTML element identifier
   */
  htmlElementId?: string;
} & ComponentProps<typeof HostedField>;

const SecurityCode = ({
  label,
  required,
  htmlElementId = CreditCardPCIFields.SecurityCode,
  hasError,
  tooltip,
}: SecurityCodeProps) => (
  <HostedField
    label={label}
    hasError={hasError}
    required={required}
    tooltip={tooltip}
  >
    <InputSocket id={htmlElementId} hasError={hasError} />
  </HostedField>
);

export default SecurityCode;
